import Observable from "zen-observable";
/**
 * @description: Listen to a heirachy of streams, first in list will take precedence. Searches for 'key' given.
 */
var ObserveWithPriority = /** @class */ (function () {
    function ObserveWithPriority(props) {
        var _this = this;
        this.listeners = [];
        this.observers = [];
        this.data = [];
        this.key = props.key;
        props.streams.forEach(function (stream, index) {
            _this.listenToStream(index, stream, function () {
                _this.observers.forEach(function (observer) {
                    observer.next(_this.getData());
                });
            });
        });
    }
    ObserveWithPriority.prototype.subscribe = function (onNext) {
        var _this = this;
        return new Observable(function (observer) {
            _this.observers.push(observer);
            return function () {
                _this.observers = _this.observers.filter(function (t) { return t !== observer; });
            };
        }).subscribe(onNext);
    };
    ObserveWithPriority.prototype.getData = function () {
        var _this = this;
        var obj = {};
        this.data
            .slice(0, this.data.length)
            .reverse()
            .forEach(function (test) {
            if (test && test[_this.key]) {
                obj = test;
            }
        });
        return obj;
    };
    ObserveWithPriority.prototype.listenToStream = function (index, service, update) {
        var _this = this;
        this.listeners[index] = service.subscribe(function (data) {
            _this.data[index] = data;
            update();
        }, undefined, function () {
            _this.data[index] = null;
            update();
            _this.listenToStream(index, service, update);
        });
    };
    return ObserveWithPriority;
}());
export default ObserveWithPriority;
